import React from 'react';
import { Modal } from 'antd';
import { IDataModal } from '@/interfaces/dataModal';
import GoodReceiveItemTable from './good-receive-item-table';
import { IGoodReceiveItem } from '@/interfaces/goodReceive';

interface IProps {
  dataModal?: IDataModal<IGoodReceiveItem[]>;
  handleOk: () => void;
  handleCancel: () => void;
}

const GoodReceiveItemTableModal = ({
  dataModal,
  handleOk,
  handleCancel,
}: IProps) => {
  return (
    <Modal
      title={'Invoice Item'}
      open={dataModal?.open}
      onOk={() => handleOk()}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      width={1400}
      footer={false}
    >
      <div className="flex flex-col gap-3">
        <GoodReceiveItemTable items={dataModal?.item || []} />
      </div>
    </Modal>
  );
};

export default GoodReceiveItemTableModal;
